module.exports = __webpack_public_path__ + "img/red-desert-0.aa2f5893.png";